import { EVENTS } from '../utils/constants.js'
import makeLogout from '../applications/makeLogout.js'

class OnLogoutRequested {
  static register(context) {
    context.events.handle(EVENTS.LOGOUT_REQUESTED, async payload => {
      try {
        await makeLogout(context, payload)
      } catch (error) {
        console.log('🚀 ~ OnLogoutRequested ~ register ~ error:', error)
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnLogoutRequested
